module.exports = __webpack_public_path__ + "static/media/jason-momoa-loop-2.6bbe1346.jpg";